import React, { Component } from "react";
import CssClasses from "./EventGroupItemLiveGeneric.css";
import BetTypeButton from "../UI/BetTypeButton/BetTypeButton";
import OddButton from "../UI/OddButton/OddButton";
import SiteIcons from "../../assets/fonts/site_icons/style.css";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import Auxx from "../../HOCs/AUXX/Auxx";
//import { GetConvertedOdds } from "../../HOCs/Helpers/OddConverter";
import * as SortTypes from "../../HOCs/Constants/SortTypes";
import { reverseArray } from "../../HOCs/Helpers/Utilities";

import iconVolleyballBall from "../../assets/images/icons/icon_volleyball_ball.png";
import iconTableTennisBall from "../../assets/images/icons/icon_table_tennis_ball.png";

import beepHigh from "../../assets/sounds/beep_high.mp3";
import beepMedium from "../../assets/sounds/beep_medium.mp3";

class EventGroupItemLiveGeneric extends Component {
  sortedHeaderButtons = [];
  lastSportID = -1;
  betTypesWithLongNames = [67, 1108];

  state = {
    currentActiveBetTypeID: 2,
    hasAdditionalColumnWithMargin: false
  };

  componentDidUpdate() {
    this.handleHeaderButtons();

    //provjeri ako je nestao otvoreni extra bets
    if (this.props.liveExtraBetsID > 0) {
      //provjeri ako je nestala
      //dohvati mec
      let match = this.props.matches.find(
        x => x.id === this.props.liveExtraBetsID
      );

      //aako vise nema, zatvori
      if (match === undefined || match.extraBetsCount < 1) {
        this.props.onSetLiveExtraBetsID(-1);

        //nakon timeouta upali
        setTimeout(() => {
          this.props.setCanShowExtraLiveBets(true);
          console.log("PALIM...");
        }, 1000);
      }
    }
  }

  componentWillMount() {
    this.handleHeaderButtons();
  }

  handleHeaderButtons() {
    //sortiraj headerbuttons
    this.sortedHeaderButtons = this.props.headerButtons.sort((a, b) => {
      return parseInt(a.HederRedoslijed, 10) - parseInt(b.HederRedoslijed, 10); //asc sort
    });

    //i odaberi prvog po defaultu
    let first = this.sortedHeaderButtons[0];

    if (this.props.liveSportID !== this.lastSportID) {
      //bilo promjene, gazi odma
      this.lastSportID = this.props.liveSportID;

      if (first) {
        //odaberi ga po defaultu
        this.btnChangeBetTypeClick(first.svoID);
      }
    }
  }

  render() {
    //define header colors
    let titleRowClasses = [CssClasses.boxTitleRow];
    let headerRowClass = CssClasses.headerRowColorDefault;
    let mainRowClass = CssClasses.mainRowColorDefault;
    let altRowClass = CssClasses.alternateRowDefault;
    let btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightDefault;
    let btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveDefault;
    let leagueHeader = CssClasses.leagueHeaderDefault;

    //i dodaj boju ovisno o sportu
    switch (this.props.currentSportID) {
      case 1:
        titleRowClasses.push(CssClasses.colorBaseball);
        break;
      case 2: //basketball
        headerRowClass = CssClasses.headerRowColorBasketball;
        mainRowClass = CssClasses.mainRowColorBasketball;
        altRowClass = CssClasses.alternateRowBasketball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightBasketball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveBasketball;
        leagueHeader = CssClasses.leagueHeaderBasketball;
        break;
      case 3: //baseball
        headerRowClass = CssClasses.headerRowColorBaseball;
        mainRowClass = CssClasses.mainRowColorBaseball;
        altRowClass = CssClasses.alternateRowBaseball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightBaseball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveBaseball;
        leagueHeader = CssClasses.leagueHeaderBaseball;
        break;
      case 4: //hockey
        headerRowClass = CssClasses.headerRowColorHockey;
        mainRowClass = CssClasses.mainRowColorHockey;
        altRowClass = CssClasses.alternateRowHockey;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightHockey;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveHockey;
        leagueHeader = CssClasses.leagueHeaderHockey;
        break;
      case 5: //tennis
        headerRowClass = CssClasses.headerRowColorTennis;
        mainRowClass = CssClasses.mainRowColorTennis;
        altRowClass = CssClasses.alternateRowTennis;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightTennis;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveTennis;
        leagueHeader = CssClasses.leagueHeaderTennis;
        break;
      case 6: //handball
        headerRowClass = CssClasses.headerRowColorHandball;
        mainRowClass = CssClasses.mainRowColorHandball;
        altRowClass = CssClasses.alternateRowHandball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightHandball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveHandball;
        leagueHeader = CssClasses.leagueHeaderHandball;
        break;
      case 12: //rugby
        headerRowClass = CssClasses.headerRowColorRugby;
        mainRowClass = CssClasses.mainRowColorRugby;
        altRowClass = CssClasses.alternateRowRugby;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightRugby;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveRugby;
        leagueHeader = CssClasses.leagueHeaderRugby;
        break;
      case 16: //Football
        headerRowClass = CssClasses.headerRowColorFootball;
        mainRowClass = CssClasses.mainRowColorFootball;
        altRowClass = CssClasses.alternateRowFootball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightFootball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveFootball;
        leagueHeader = CssClasses.leagueHeaderFootball;
        break;
      case 19: //Snooker
        headerRowClass = CssClasses.headerRowColorSnooker;
        mainRowClass = CssClasses.mainRowColorSnooker;
        altRowClass = CssClasses.alternateRowSnooker;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightSnooker;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveSnooker;
        leagueHeader = CssClasses.leagueHeaderSnooker;
        break;
      case 20: //TableTennis
        headerRowClass = CssClasses.headerRowColorTableTennis;
        mainRowClass = CssClasses.mainRowColorTableTennis;
        altRowClass = CssClasses.alternateRowTableTennis;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightTableTennis;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveTableTennis;
        leagueHeader = CssClasses.leagueHeaderTableTennis;
        break;
      case 23: //volleyball
        headerRowClass = CssClasses.headerRowColorVolleyball;
        mainRowClass = CssClasses.mainRowColorVolleyball;
        altRowClass = CssClasses.alternateRowVolleyball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightVolleyball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveVolleyball;
        leagueHeader = CssClasses.leagueHeaderVolleyball;
        break;
      case 29: //futsal
        headerRowClass = CssClasses.headerRowColorFutsal;
        mainRowClass = CssClasses.mainRowColorFutsal;
        altRowClass = CssClasses.alternateRowFutsal;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightFutsal;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveFutsal;
        leagueHeader = CssClasses.leagueHeaderFutsal;
        break;
      case 31: //Badminton
        headerRowClass = CssClasses.headerRowColorBadminton;
        mainRowClass = CssClasses.mainRowColorBadminton;
        altRowClass = CssClasses.alternateRowBadminton;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightBadminton;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveBadminton;
        leagueHeader = CssClasses.leagueHeaderBadminton;
        break;
      default:
        //titleRowClasses.push(CssClasses.colorFootball);
        break;
    }

    var sport = this.props.sportInfo.find(
      x => x.sportID === this.props.currentSportID
    );

    if (!sport) {
      console.log("---------> MISSING SPORT!!!");
      console.log("---------> MATCHES ARE ", this.props.matches);

      return null;
    }

    // console.log('SPORT IS ', sport);
    // console.log('SPORT ID IS ', this.props.currentSportID);

    //pushaj
    titleRowClasses.push(headerRowClass);

    let rowCounter = 0;

    //sortiraj po vremenu silazno
    // let sortedMatches = this.props.matches.sort((a, b) => {
    //   return parseInt(b.startTimeMIN, 10) - parseInt(a.startTimeMIN, 10); //reverse sort
    // });

    let sortedMatches = [];

    if (this.props.currentSortType === SortTypes.SORT_TIME_DESC) {
      //vrijeme silazno
      sortedMatches = this.props.matches.sort(function(a, b) {
        if (a.timeMatchStartDiff === b.timeMatchStartDiff) {
          if (a.tournamentName === b.tournamentName) {
            return a.homeTeam > b.homeTeam ? 1 : -1;
          } else if (a.tournamentName > b.tournamentName) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.timeMatchStartDiff > b.timeMatchStartDiff) {
          return 1;
        } else {
          return -1;
        }
      });
    } else if (this.props.currentSortType === SortTypes.SORT_TIME_ASC) {
      //vrijeme silazno
      sortedMatches = this.props.matches.sort(function(a, b) {
        if (a.timeMatchStartDiff === b.timeMatchStartDiff) {
          if (a.tournamentName === b.tournamentName) {
            return a.homeTeam > b.homeTeam ? 1 : -1;
          } else if (a.tournamentName > b.tournamentName) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.timeMatchStartDiff > b.timeMatchStartDiff) {
          return -1;
        } else {
          return 1;
        }
      });
    } else if (this.props.currentSortType === SortTypes.SORT_LEAGUE_AZ) {
      //vrijeme silazno
      sortedMatches = this.props.matches.sort(function(a, b) {
        if (a.tournamentName === b.tournamentName) {
          return a.homeTeam > b.homeTeam ? 1 : -1;
        } else if (a.tournamentName > b.tournamentName) {
          return 1;
        } else {
          return -1;
        }
      });
    }

    let lastLeagueName = "";

    //console.log(sortedMatches);

    //define middle section markup
    let middleSectionHeaderMarkup = this.getMiddleSectionTitleMarkup(
      this.state.currentActiveBetTypeID,
      sortedMatches
    );

    let mainBetHeaderTitle = "";

    //nadji svoid
    let betTexts = this.props.allBetsText
      .filter(x => x.SportID === this.props.currentSportID)
      .map(x => x.svoID); //fudbol
    //let bets = this.
    let bet = this.props.allBets.find(
      x => betTexts.includes(x.svoID) && x.kpID === 1
    );

    if (bet) {
      mainBetHeaderTitle = this.props.allBetsText.find(
        x => x.svoID === bet.svoID
      ).HederNaziv;
    } else {
      mainBetHeaderTitle = "";
    }

    return (
      <div className={CssClasses.container}>
        <audio
          ref={sound => {
            this.beepHigh = sound;
          }}
        >
          <source src={beepHigh} type="audio/mpeg" />
        </audio>
        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        <div className={[CssClasses.boxBetTypes, mainRowClass].join(" ")}>
          {this.sortedHeaderButtons.map(btnInfo => {
            let isActive =
              btnInfo.svoID === this.state.currentActiveBetTypeID &&
              !this.props.isShowingBonusInfo;

            //ako je trenutno kurac vani
            if (this.props.liveExtraBetsID > 0) {
              isActive = false;
            }

            return (
              <BetTypeButton
                onButtonClicked={id => this.btnChangeBetTypeClick(id)}
                title={btnInfo.HederNaziv}
                key={btnInfo.svoID}
                id={btnInfo.svoID}
                isActive={isActive}
                inLiveEventGroup={true}
                isLightTheme={this.props.currentActiveLiveTheme === 2}
                sportID={this.props.currentSportID}
              />
            );
          })}
        </div>
        <div className={titleRowClasses.join(" ")}>
          &nbsp;
          {/* last column for button +102 */}
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            &nbsp;
          </div>
          {/* middle section */}
          {middleSectionHeaderMarkup}
          {/* main left section */}
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            2
          </div>
          {sport.numberOfMainBets === 3 ? (
            <div className={CssClasses.oddBox}>
              X
              <div className={CssClasses.oddBoxTitle}>{mainBetHeaderTitle}</div>
            </div>
          ) : null}
          <div className={CssClasses.oddBox}>
            1
            {sport.numberOfMainBets === 2 ? (
              <div
                className={[
                  CssClasses.oddBoxTitle,
                  CssClasses.titleForTwoBets
                ].join(" ")}
              >
                {mainBetHeaderTitle}
              </div>
            ) : null}
          </div>
        </div>

        <div className={CssClasses.matchesContainer}>
          {sortedMatches.map(match => {
            let availableBets = match.betInfo;
            rowCounter++;

            let rowClasses = [CssClasses.boxEventItem];

            if (rowCounter % 2 === 1) {
              rowClasses.push(altRowClass);
            } else {
              rowClasses.push(mainRowClass);
            }

            // console.log("MATCH IS ", match);
            // console.log("AV BETS ARE ", availableBets);

            let hasGroup =
              lastLeagueName !== match.tournamentName &&
              this.props.currentSortType === SortTypes.SORT_LEAGUE_AZ;

            lastLeagueName = match.tournamentName;

            // console.log(
            //   "CSH: " + match.scoreTotalHome + " FOR " + match.homeTeam
            // );

            return (
              <Auxx key={match.id}>
                {hasGroup ? (
                  <div className={leagueHeader}>{match.tournamentName}</div>
                ) : null}

                <div className={[rowClasses.join(" ")]}>
                  <span style={{ visibility: "hidden" }}>ID: {match.id}</span>
                  <span
                    className={[
                      CssClasses.currentTime
                      //,match.currentTime.indexOf("'") > -1 ? CssClasses.flickers : "" // ako ima oznaku minute onda je u tijeku pa neka blica
                    ].join(" ")}
                  >
                    {match.currentTime && match.currentTime !== "" ? (
                      match.currentTime
                    ) : (
                      <span>&nbsp;</span>
                    )}
                  </span>
                  <div
                    className={[
                      CssClasses.matchInfoContainer,
                      this.betTypesWithLongNames.includes(
                        this.state.currentActiveBetTypeID
                      )
                        ? CssClasses.narrowerMatchInfo
                        : null
                    ].join(" ")}
                  >
                    <div className={CssClasses.teamsGroup}>
                      <div className={CssClasses.teamHome}>
                        {match.homeTeam}
                      </div>
                      <div className={CssClasses.teamGuest}>
                        {match.guestTeam}
                      </div>
                    </div>
                    {match.scoreTotalHome !== "" ? (
                      <div className={CssClasses.totalScoreBox}>
                        <div
                          className={[
                            CssClasses.totalScoreHome,
                            match.homeChangeDirection > 0
                              ? CssClasses.flickers
                              : ""
                          ].join(" ")}
                        >
                          {match.scoreTotalHome}
                        </div>
                        <div
                          className={[
                            CssClasses.totalScoreGuest,
                            match.guestChangeDirection > 0
                              ? CssClasses.flickers
                              : ""
                          ].join(" ")}
                        >
                          {match.scoreTotalGuest}
                        </div>
                      </div>
                    ) : null}

                    {this.props.currentSportID === 5 ? ( //tenis
                      <Auxx>
                        <div className={CssClasses.currentServeBox}>
                          <div className={CssClasses.currentServeHome}>
                            {match.homeHasServe ? (
                              <span
                                className={[
                                  SiteIcons.site_icon_tennis_ball
                                  //,CssClasses.fadingAnim
                                ].join(" ")}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                          <div className={CssClasses.currentServeGuest}>
                            {match.guestHasServe ? (
                              <span
                                className={[
                                  SiteIcons.site_icon_tennis_ball
                                  //,CssClasses.fadingAnim
                                ].join(" ")}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                        </div>
                        <div className={CssClasses.currentGemBox}>
                          <div className={CssClasses.currentGemHome}>
                            {match.scoreGemHome}
                          </div>
                          <div className={CssClasses.currentGemGuest}>
                            {match.scoreGemGuest}
                          </div>
                        </div>
                      </Auxx>
                    ) : null}

                    {this.props.currentSportID === 20 ? ( //table tenis
                      <Auxx>
                        <div className={CssClasses.currentServeBox}>
                          <div className={CssClasses.currentServeHome}>
                            {match.homeHasServe ? (
                              <img
                                src={iconTableTennisBall}
                                alt=""
                                className={[
                                  CssClasses.currentServeVolleyball,
                                  //,CssClasses.fadingAnim
                                  CssClasses.moreMargin
                                ].join(" ")}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                          <div className={CssClasses.currentServeGuest}>
                            {match.guestHasServe ? (
                              <img
                                src={iconTableTennisBall}
                                alt=""
                                className={[
                                  CssClasses.currentServeVolleyball,
                                  //,CssClasses.fadingAnim
                                  CssClasses.moreMargin
                                ].join(" ")}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                        </div>
                      </Auxx>
                    ) : null}

                    {this.props.currentSportID === 23 ? ( //odbojka
                      <Auxx>
                        <div className={CssClasses.currentServeBox}>
                          <div className={CssClasses.currentServeHome}>
                            {match.homeHasServe ? (
                              <img
                                src={iconVolleyballBall}
                                alt=""
                                className={[
                                  CssClasses.currentServeVolleyball,
                                  //,CssClasses.fadingAnim
                                  CssClasses.moreMargin
                                ].join(" ")}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                          <div className={CssClasses.currentServeGuest}>
                            {match.guestHasServe ? (
                              <img
                                src={iconVolleyballBall}
                                alt=""
                                className={[
                                  CssClasses.currentServeVolleyball
                                  //,CssClasses.fadingAnim
                                ].join(" ")}
                              />
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                        </div>
                      </Auxx>
                    ) : null}

                    {match.setInfo.map(set => {
                      if (set.homeScore === "" || set.guestScore === "") {
                        return null;
                      }

                      let classNames = [];

                      if (!set.isCurrentSet) {
                        classNames.push(CssClasses.previousScoreBox);
                        classNames.push(headerRowClass);
                      } else {
                        classNames.push(CssClasses.currentScoreBox);
                      }

                      return (
                        <div className={classNames.join(" ")} key={set.id}>
                          <div className={CssClasses.previousScoreHome}>
                            {set.homeScore}
                          </div>
                          <div className={CssClasses.previousScoreGuest}>
                            {set.guestScore}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* button for extra bets +102 */}

                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.withLeftBorder,
                      CssClasses.withLeftPadding
                    ].join(" ")}
                  >
                    <OddButton
                      offsetGeneric={true}
                      moreBetsClass={btnMoreBetsHighlightClass}
                      moreBetsActiveClass={btnMoreBetsActiveClass}
                      onButtonClicked={matchID =>
                        this.btnShowAdditionalBetsClick(matchID)
                      }
                      moreBetsCount={match.extraBetsCount}
                      matchID={match.id}
                      isMoreBets={true}
                      isActive={this.props.liveExtraBetsID === match.id}
                    />
                  </div>
                  {/* middle section buttons (special bets from header) */}
                  {this.getMiddleSectionOddButtonsMarkup(
                    this.state.currentActiveBetTypeID,
                    availableBets,
                    match
                  )}
                  {/* main (left) section buttons - main bets  */}

                  <div className={CssClasses.mainBetsGroup}>
                    <div
                      className={[
                        CssClasses.oddBox,
                        CssClasses.withRightPadding
                      ].join(" ")}
                    >
                      <OddButton
                        onButtonClicked={(matchID, betID) =>
                          this.btnChangeBetClick(matchID, betID)
                        }
                        betInfo={availableBets.find(
                          x => x.kategorijaPonudeID === 1 && x.shortName === "2"
                        )}
                        activeBets={this.props.ticketPairInfo.map(
                          x => x.coefID
                        )}
                        offsetGeneric={true}
                        oddType={this.props.currentOddFormat}
                      />
                    </div>

                    {sport.numberOfMainBets === 3 ? (
                      <div className={CssClasses.oddBox}>
                        {" "}
                        <OddButton
                          onButtonClicked={(matchID, betID) =>
                            this.btnChangeBetClick(matchID, betID)
                          }
                          betInfo={availableBets.find(
                            x =>
                              x.kategorijaPonudeID === 1 && x.shortName === "X"
                          )}
                          activeBets={this.props.ticketPairInfo.map(
                            x => x.coefID
                          )}
                          offsetGeneric={true}
                          oddType={this.props.currentOddFormat}
                        />
                      </div>
                    ) : null}

                    <div className={CssClasses.oddBox}>
                      {" "}
                      <OddButton
                        onButtonClicked={(matchID, betID) =>
                          this.btnChangeBetClick(matchID, betID)
                        }
                        betInfo={availableBets.find(
                          x => x.kategorijaPonudeID === 1 && x.shortName === "1"
                        )}
                        activeBets={this.props.ticketPairInfo.map(
                          x => x.coefID
                        )}
                        offsetGeneric={true}
                        oddType={this.props.currentOddFormat}
                      />
                    </div>
                  </div>
                  {/* <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.statsCustomOddBox
                    ].join(" ")}
                  >
                    <span
                      className={[
                        SiteIcons.site_icon_statistics,
                        CssClasses.statsIcon
                      ].join(" ")}
                    />
                  </div> */}
                </div>
              </Auxx>
            );
          })}
        </div>
      </div>
    );
  }

  getMiddleSectionTitleMarkup = (svoID, matches) => {
    //ako su aktivna dodatna kladjenja, nema ovog!
    if (this.props.liveExtraBetsID > 0 || !this.props.canShowExtraBetsLive) {
      return null;
    }

    //dohvati bet iz betova
    let okladaTxt = this.props.allBetsText.find(x => x.svoID === svoID);
    let coefs = [];

    for (let i = 0; i < matches.length; i++) {
      const match = matches[i];
      coefs = match.betInfo.filter(x => x.sportVrstaOkladaID === svoID);
      if (coefs.length > 0) {
        break;
      }
    }

    if (okladaTxt === undefined) {
      //BET
      console.log("ERROR: bet not found for SVOID " + svoID);
      return null;
    }

    //coefs are
    // console.log("OKLADA TEIXTE JE ", okladaTxt);
    // console.log("COEFS ", coefs);

    //grupiraj
    var grouped = coefs.reduce(function(r, a) {
      r[a.betID] = r[a.betID] || [];
      r[a.betID].push(a);
      return r;
    }, Object.create(null));

    //console.log("GROUPED COEFS ARE ", grouped);

    //uzmi prvi grupirani kao mjerodavan
    var coefForRender =
      coefs && coefs.length > 0 ? grouped[coefs[0].betID] : [];

    if (coefForRender.length === 0) {
      //nema nicega, popuni nicim u duzini broja betova da bude nesto uvijek
      for (let x = 0; x < okladaTxt.BrojTipova; x++) {
        coefForRender.push({});
      }
    }

    //reversaj ih zbog prikaza
    coefForRender = reverseArray(coefForRender);

    //console.log("COEF FOR RENDER ", coefForRender);

    //printaj naziv
    //console.log("BET IS ", okladaTxt);
    //console.log("BET DETAILS ", oklada);

    //slozi u petlji sto treba
    var numOfCols = okladaTxt.BrojTipova;
    var hasBonusColForMargin = false;

    //ako imamo spec naziv a ima 3 ili vise tipova, dodaj +1 u num of cols
    if (numOfCols >= 3 && okladaTxt.SpecNaziv.length > 0) {
      //ima, crtaj jos jednu
      numOfCols++;
      hasBonusColForMargin = true;

      if (!this.state.hasAdditionalColumnWithMargin) {
        this.setState({ hasAdditionalColumnWithMargin: true });
      }
    }

    var idxForTitle =
      numOfCols % 2 === 0
        ? Math.floor(numOfCols * 0.5)
        : Math.floor((numOfCols - 1) * 0.5);
    var isEvenNumberOfTypes = numOfCols % 2 === 0;
    var hasExtraField = numOfCols < 3 || hasBonusColForMargin;

    return (
      <Auxx>
        {coefForRender.map((coef, index) => {
          var hasTitle = index === idxForTitle;

          if (index === 0) {
            //prvi element
            return (
              <div
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
                key={index + 1}
              >
                {coefs.find(x => x.order === coefForRender.length - index) !==
                undefined
                  ? coefs.find(x => x.order === coefForRender.length - index)
                      .shortName
                  : ""}
              </div>
            );
          }
          if (index === coefs.length - 1) {
            //zadnji element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  !hasExtraField ? CssClasses.withLeftBorder : "",
                  !hasExtraField ? CssClasses.borderInTitleRow : "",
                  !hasExtraField ? CssClasses.withLeftPadding : ""
                ].join(" ")}
              >
                {coefs.find(x => x.order === coefForRender.length - index) !==
                undefined
                  ? coefs.find(x => x.order === coefForRender.length - index)
                      .shortName
                  : ""}
                {hasTitle ? (
                  <div
                    className={[
                      CssClasses.oddBoxTitle,
                      numOfCols === 4 ? CssClasses.titleForTwoBets : null
                    ].join(" ")}
                  >
                    {okladaTxt.HederNaziv}
                  </div>
                ) : null}
              </div>
            );
          }
          //izmedju elementi
          return (
            <div className={CssClasses.oddBox} key={index + 1}>
              {coefs.find(x => x.order === coefForRender.length - index) !==
              undefined
                ? coefs.find(x => x.order === coefForRender.length - index)
                    .shortName
                : ""}
              {hasTitle ? (
                <div
                  className={[
                    CssClasses.oddBoxTitle,
                    numOfCols === 4 ? CssClasses.titleForTwoBets : null
                  ].join(" ")}
                >
                  {okladaTxt.HederNaziv}
                </div>
              ) : null}
            </div>
          );
        })}

        {hasExtraField ? (
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding,
              this.betTypesWithLongNames.includes(
                this.state.currentActiveBetTypeID
              )
                ? CssClasses.widerForLongMargins
                : null
            ].join(" ")}
          >
            &nbsp;
          </div>
        ) : null}
      </Auxx>
    );

    // if (okladaTxt.BrojTipova === 2) {
    //   return (
    //     <Auxx>
    //       <div
    //         className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
    //           " "
    //         )}
    //       >
    //         {coefs.find(x => x.order === 2) !== undefined
    //           ? coefs.find(x => x.order === 2).shortName
    //           : ""}
    //       </div>
    //       <div className={CssClasses.oddBox}>
    //         {coefs.find(x => x.order === 1) !== undefined
    //           ? coefs.find(x => x.order === 1).shortName
    //           : ""}
    //         <div className={CssClasses.oddBoxTitle}>{okladaTxt.HederNaziv}</div>
    //       </div>
    //       <div
    //         className={[
    //           CssClasses.oddBox,
    //           CssClasses.withLeftBorder,
    //           CssClasses.borderInTitleRow,
    //           CssClasses.withLeftPadding
    //         ].join(" ")}
    //       >
    //         &nbsp;
    //       </div>
    //     </Auxx>
    //   );
    // }

    // if (okladaTxt.BrojTipova === 3) {
    //   return (
    //     <Auxx>
    //       <div
    //         className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
    //           " "
    //         )}
    //       >
    //         {coefs.find(x => x.order === 3) !== undefined
    //           ? coefs.find(x => x.order === 3).shortName
    //           : ""}
    //       </div>
    //       <div className={CssClasses.oddBox}>
    //         {coefs.find(x => x.order === 2) !== undefined
    //           ? coefs.find(x => x.order === 2).shortName
    //           : ""}
    //         <div className={CssClasses.oddBoxTitle}>{okladaTxt.HederNaziv}</div>
    //       </div>
    //       <div
    //         className={[
    //           CssClasses.oddBox,
    //           CssClasses.withLeftBorder,
    //           CssClasses.borderInTitleRow,
    //           CssClasses.withLeftPadding
    //         ].join(" ")}
    //       >
    //         {coefs.find(x => x.order === 1) !== undefined
    //           ? coefs.find(x => x.order === 1).shortName
    //           : ""}
    //       </div>
    //     </Auxx>
    //   );
    // }

    // if (okladaTxt.BrojTipova === 4) {
    //   return (
    //     <Auxx>
    //       <div
    //         className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
    //           " "
    //         )}
    //       >
    //         {coefs.find(x => x.order === 4) !== undefined
    //           ? coefs.find(x => x.order === 4).shortName
    //           : ""}
    //       </div>
    //       <div className={CssClasses.oddBox}>
    //         {coefs.find(x => x.order === 3) !== undefined
    //           ? coefs.find(x => x.order === 3).shortName
    //           : ""}
    //         <div className={CssClasses.oddBoxTitle}>{okladaTxt.HederNaziv}</div>
    //       </div>
    //       <div className={CssClasses.oddBox}>
    //         {coefs.find(x => x.order === 2) !== undefined
    //           ? coefs.find(x => x.order === 2).shortName
    //           : ""}
    //         <div className={CssClasses.oddBoxTitle}>{okladaTxt.HederNaziv}</div>
    //       </div>
    //       <div
    //         className={[
    //           CssClasses.oddBox,
    //           CssClasses.withLeftBorder,
    //           CssClasses.borderInTitleRow,
    //           CssClasses.withLeftPadding
    //         ].join(" ")}
    //       >
    //         {coefs.find(x => x.order === 1) !== undefined
    //           ? coefs.find(x => x.order === 1).shortName
    //           : ""}
    //       </div>
    //     </Auxx>
    //   );
    // }
  };

  getMiddleSectionOddButtonsMarkup = (svoGrupID, availableBets, match) => {
    //ako su aktivna dodatna kladjenja, nema ovog!
    if (this.props.liveExtraBetsID > 0 || !this.props.canShowExtraBetsLive) {
      return null;
    }

    let bets = this.props.allBets.filter(
      x =>
        x.svoGrupID === svoGrupID &&
        x.UtakmicaID === match.id &&
        x.Aktivno === true
    );

    bets.sort((a, b) => {
      return parseFloat(a.PosebnaVrijednost) - parseFloat(b.PosebnaVrijednost); //asc sort
    });

    //nadji prvi bet
    let bet = bets[0];

    let betText = this.props.allBetsText.find(
      x => x.svoID === (bet ? bet.svoID : svoGrupID)
    );

    //svogrupid oznacava grupu
    //svoid je specifina oklada
    //po grupi dohvatimo glavnu da se zna broj oklada jer je to samo kod glavne popunjeno

    let rawHeaderOklada = this.props.allBetsText.find(
      x => x.svoID === svoGrupID
    );

    //filtriraj available bets
    availableBets = bet
      ? availableBets.filter(x => x.betID === bet.IDOklada)
      : [];

    if (betText === undefined) {
      console.log("UNDEFINED BETEXT FOR SVOID " + svoGrupID);
      return null;
    } else {
      //console.log("FOUND BET TEXT ", betText);
    }

    if (availableBets.length === 0) {
      //nema nicega, popuni nicim u duzini broja betova da bude nesto uvijek
      for (let x = 0; x < betText.BrojTipova; x++) {
        availableBets.push({});
      }
    }

    if (match.id === 18572396 || match.id === 18456444) {
      console.log("BET TEXT ", betText);
      console.log("RAW BET TEXT ", rawHeaderOklada);
      //console.log("ALL BETS ", this.props.allBets);
      //console.log("BETS ", bets);
      // console.log(
      //   "MATCH BETS ARE ",
      //   this.props.allBets.filter(x => x.UtakmicaID === match.id)
      // );
      console.log("AVAILABLE BETS ", availableBets);
      console.log("BET IS ", bet);
      console.log("MATCH IS ", match);
    }

    var OkladaNaziv = rawHeaderOklada.SpecNaziv; //bitno isto iz raw oklade jer ne popuni za ostale ovo!
    var oklada = bet;
    var tmpOkladaTxt = betText;

    var tmpString = "";
    var indReplace = 1;

    if (!oklada) {
      OkladaNaziv = <p>&nbsp;</p>;
    }

    var tmpPosebnaV = oklada ? oklada.PosebnaVrijednost : "";
    if (tmpOkladaTxt.PosebnaVrijednostGrup.length > 0)
      tmpPosebnaV = tmpPosebnaV + "/" + tmpOkladaTxt.PosebnaVrijednostGrup;

    //pripremi naziv
    if (oklada && OkladaNaziv.indexOf("$") > -1) {
      // if (tmpOkladaTxt.predznakNaslov === 1) {
      //   var posVrj = tmpPosebnaV;
      //   if (parseFloat(posVrj) > 0) {
      //     posVrj = "+" + posVrj;
      //   }
      //   OkladaNaziv = OkladaNaziv.replace("1$", posVrj);
      // } else

      if (tmpPosebnaV.indexOf("-") > 0 && tmpPosebnaV.indexOf("/-") === -1) {
        tmpString = tmpPosebnaV.replace("and", "-").split("-");
        indReplace = 1;

        for (let i = 0; i < tmpString.length; i++) {
          OkladaNaziv = OkladaNaziv.replace(
            indReplace.toString() + "$",
            tmpString[i]
          );
          indReplace++;
        }
      } else {
        tmpString = tmpPosebnaV.split("/");
        indReplace = 1;

        for (let i = 0; i < tmpString.length; i++) {
          OkladaNaziv = OkladaNaziv.replace(
            indReplace.toString() + "$",
            tmpString[i]
          );
          indReplace++;
        }
      }
    }

    //slozi u petlji sto treba
    var numOfCols = availableBets.length;
    var hasBonusColForMargin = false;

    //ako imamo spec naziv a ima 3 ili vise tipova, dodaj +1 u num of cols
    if (
      (numOfCols >= 3 && OkladaNaziv.length > 0) ||
      this.state.hasAdditionalColumnWithMargin
    ) {
      //ima, crtaj jos jednu
      numOfCols++;
      hasBonusColForMargin = true;

      //podesi u state ako jos nije
      if (!this.state.hasAdditionalColumnWithMargin) {
        this.setState({ hasAdditionalColumnWithMargin: true });
      }
    }

    var idxForTitle =
      numOfCols % 2 === 0
        ? Math.floor(numOfCols * 0.5)
        : Math.floor((numOfCols - 1) * 0.5);
    var isEvenNumberOfTypes = numOfCols % 2 === 0;
    var hasExtraField = numOfCols < 3 || hasBonusColForMargin;

    return (
      <Auxx>
        {availableBets.map((tip, index) => {
          if (index === 0) {
            //prvi element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
              >
                <OddButton
                  onButtonClicked={(matchID, betID) =>
                    this.btnChangeBetClick(matchID, betID)
                  }
                  betInfo={
                    bet !== undefined
                      ? availableBets.find(
                          x =>
                            x.betID === bet.IDOklada &&
                            x.order === availableBets.length - index
                        )
                      : null
                  }
                  activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                  offsetGeneric={true}
                  oddType={this.props.currentOddFormat}
                />
              </div>
            );
          }
          if (index === availableBets.length - 1) {
            //zadnji element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  !hasExtraField ? CssClasses.withLeftBorder : "",
                  !hasExtraField ? CssClasses.withLeftPadding : ""
                ].join(" ")}
              >
                <OddButton
                  onButtonClicked={(matchID, betID) =>
                    this.btnChangeBetClick(matchID, betID)
                  }
                  betInfo={
                    bet !== undefined
                      ? availableBets.find(
                          x =>
                            x.betID === bet.IDOklada &&
                            x.order === availableBets.length - index
                        )
                      : null
                  }
                  activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                  offsetGeneric={true}
                  oddType={this.props.currentOddFormat}
                />
              </div>
            );
          }
          //izmedju elementi
          return (
            <div key={index + 1} className={CssClasses.oddBox}>
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={
                  bet !== undefined
                    ? availableBets.find(
                        x =>
                          x.betID === bet.IDOklada &&
                          x.order === availableBets.length - index
                      )
                    : null
                }
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={true}
                oddType={this.props.currentOddFormat}
              />
            </div>
          );
        })}

        {hasExtraField ? (
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.withLeftPadding,
              this.betTypesWithLongNames.includes(
                this.state.currentActiveBetTypeID
              )
                ? CssClasses.widerForLongMargins
                : null
            ].join(" ")}
          >
            <span className={CssClasses.oddLegend}>{OkladaNaziv}</span>
          </div>
        ) : null}
      </Auxx>
    );

    //default return nis
    return null;
  };

  btnChangeBetTypeClick = id => {
    //daj zvukic
    if (this.beepHigh) {
      //daj zvukic
      this.beepHigh.play();
    }

    this.setState({
      currentActiveBetTypeID: id,
      hasAdditionalColumnWithMargin: false
    });

    //napravi novi state
    let newGroups = "," + id + ",";

    this.props.setBetGroups(newGroups);

    //ako je trenutno kurac vani
    if (this.props.liveExtraBetsID > 0 || this.props.isShowingBonusInfo) {
      //gasi extra oklade
      this.props.onSetLiveExtraBetsID(-1);

      //gasi i help ako je vani
      this.props.setIsShowingBonusInfo(false);

      //nakon timeouta upali
      setTimeout(() => {
        this.props.setCanShowExtraLiveBets(true);
        console.log("PALIM...");
      }, 1000);
    }
  };

  btnShowAdditionalBetsClick = matchID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("SHOW EXTRA bets click for MID " + matchID);

    //dodaj klasu da vidimo smanjivanje
    if (this.props.liveExtraBetsID === matchID) {
      //ugasi, klik na isti
      this.props.onSetLiveExtraBetsID(-1);
      //nakon timeouta upali
      setTimeout(() => {
        this.props.setCanShowExtraLiveBets(true);
        console.log("PALIM...");
      }, 1000);
    } else {
      //promjeni
      this.props.onSetLiveExtraBetsID(matchID);
      this.props.setCanShowExtraLiveBets(false);

      //ubij i info bez da moras provjeravat ako ga ima
      this.props.setIsShowingBonusInfo(false);

      console.log("GASIM...");

      //this.props.refreshDataCallback();
    }
  };

  btnChangeBetClick = (matchID, coefID) => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("Btn change bet click for MID " + matchID + " CID " + coefID);

    if (matchID === 0 || coefID === 0) {
      //disabled
      return;
    }

    //console.log("MATCHES ", this.props.matches);

    //nadji match
    let match = this.props.matches.find(x => x.id === matchID);
    let bet = match.betInfo.find(x => x.id === coefID);
    let sport = this.props.allSports.find(x => x.IDSport === match.sportID);

    //console.log("MATCH ", match);
    //console.log("BET ", bet);

    if (!bet.isEnabled || !bet.isShown) {
      //disabled
      return;
    }

    let oldBetInfo = this.props.ticketPairInfo.find(x => x.coefID === coefID);

    if (oldBetInfo) {
      //vec je odabran, radi remove
      this.props.onRemovePair(matchID);
    } else {
      //radi add
      console.log("Adding pair..");
      this.props.onAddPair({
        coefID: bet.id,
        betID: bet.betID,
        matchID: match.id,
        matchName:
          match.homeTeam +
          " - " +
          match.guestTeam +
          " (" +
          match.scoreTotalHome +
          ":" +
          match.scoreTotalGuest +
          ")",
        betName: this.getBetName(bet, match),
        pick: this.getPickName(bet, match),
        odds: bet.value,
        checked: true,
        isLive: true,
        isShown: true,
        isEnabled: true,
        isFix: false,
        currentTime: match.currentTime,
        tournamentName: match.tournamentName,
        sportName: sport.Naziv,
        sportID: sport.IDSport
      });
    }
  };

  getPickName = (bet, match) => {
    //nadji tu okladu
    let betText = this.props.allBetsText.find(
      x => x.svoID === bet.sportVrstaOkladaID
    );

    let betInfo = this.props.allBets.find(x => x.IDOklada === bet.betID);

    if (betText === undefined || betInfo === undefined) {
      return "???";
    }

    let desc = bet.longName;
    desc = desc.replace("d!", match.homeTeam).replace("g!", match.guestTeam);

    return desc;
  };

  getBetName = (bet, match) => {
    //console.log("ALL BETS TEXT ", this.props.allBetsText);
    //console.log("ALL BETS ", this.props.allBets);

    //nadji tu okladu
    let betText = this.props.allBetsText.find(
      x => x.svoID === bet.sportVrstaOkladaID
    );

    let betInfo = this.props.allBets.find(x => x.IDOklada === bet.betID);

    if (betText === undefined || betInfo === undefined) {
      return "???";
    }

    console.log("BET ", bet);
    console.log("BETTEXT ", betText);
    console.log("BETINFO ", betInfo);
    console.log("MATCH ", match);

    //podesi naziv brankovim algoritmom
    var OkladaNaziv = betText.DugiNaziv; //bitno isto iz raw oklade jer ne popuni za ostale ovo!
    var tmpOkladaTxt = betText;

    var tmpString = "";
    var indReplace = 1;

    if (!betInfo) {
      OkladaNaziv = "";
    }

    var tmpPosebnaV = betInfo ? betInfo.PosebnaVrijednost : "";
    if (tmpOkladaTxt.PosebnaVrijednostGrup.length > 0)
      tmpPosebnaV = tmpPosebnaV + "/" + tmpOkladaTxt.PosebnaVrijednostGrup;

    //pripremi naziv
    if (betInfo && OkladaNaziv.indexOf("$") > -1) {
      // if (tmpOkladaTxt.predznakNaslov === 1) {
      //   var posVrj = tmpPosebnaV;
      //   if (parseFloat(posVrj) > 0) {
      //     posVrj = "+" + posVrj;
      //   }
      //   OkladaNaziv = OkladaNaziv.replace("1$", posVrj);
      // } else

      if (tmpPosebnaV.indexOf("-") > 0 && tmpPosebnaV.indexOf("/-") === -1) {
        tmpString = tmpPosebnaV.replace("and", "-").split("-");
        indReplace = 1;

        for (let i = 0; i < tmpString.length; i++) {
          OkladaNaziv = OkladaNaziv.replace(
            indReplace.toString() + "$",
            tmpString[i]
          );
          indReplace++;
        }
      } else {
        tmpString = tmpPosebnaV.split("/");
        indReplace = 1;

        for (let i = 0; i < tmpString.length; i++) {
          OkladaNaziv = OkladaNaziv.replace(
            indReplace.toString() + "$",
            tmpString[i]
          );
          indReplace++;
        }
      }
    }

    // if (
    //   betInfo.PosebnaVrijednost &&
    //   betInfo.PosebnaVrijednost.indexOf(":") !== -1
    // ) {
    //   //ima rezultat, izbaci
    //   desc = desc.replace("[1$] ", "");
    // } else {
    //   //nema rezultat, ostavi kako je
    //   desc = desc.replace("1$", betInfo.PosebnaVrijednost);
    // }

    OkladaNaziv = OkladaNaziv.replace("d!", match.homeTeam).replace(
      "g!",
      match.guestTeam
    );

    return OkladaNaziv;
  };
}

const mapStateToProps = state => {
  return {
    isAppLoading: state.rrAppState.isLoading,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    prematchExtraBetsID: state.rrNavigation.prematchExtraBetsID,
    liveExtraBetsID: state.rrNavigation.liveExtraBetsID,
    currentActiveLiveTheme: state.rrAppState.currentActiveLiveTheme,
    allBetsText: state.rrSportEvent.allBetsText,
    allBets: state.rrSportEvent.allBets,
    liveSportID: state.rrNavigation.liveSportID,
    currentOddFormat: state.rrAppState.oddFormatID,
    canShowExtraBetsLive: state.rrNavigation.canShowExtraBetsLive,
    currentSortType: state.rrAppState.sortTypeID,
    isShowingBonusInfo: state.rrNavigation.isShowingBonusInfo,
    allSports: state.rrSportEvent.initialLiveSetInfo.Sportovi,
    sportInfo: state.rrSportEvent.activeLiveSports
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAddPair: pairInfo => dispatch(StoreActions.AddPair(pairInfo)),
    onRemovePair: matchID => dispatch(StoreActions.RemovePair(matchID)),
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    setBetGroups: betGroups =>
      dispatch(StoreActions.ChangeCurrentBetGroups(betGroups)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventGroupItemLiveGeneric);



// WEBPACK FOOTER //
// ./src/Components/EventGroupItemLiveGeneric/EventGroupItemLiveGeneric.js